import type { ColumnAlignType } from "primereact/column";
import type { ReactNode } from "react";

import { NEGATIVE_ACCRUAL_TYPE } from "./accrualType";

export const ACCRUALS_TABLE_COLUMN_KEYS = {
  REGISTRATION_DATE: "registrationDate",
  REGISTRATION_DATE_VALUE: "registrationDateValue",
  DESCRIPTION: "description",
  VACATION_DAYS: "vacationDays",
  TAKEN_DAYS: "takenDays",
  PRIMA_PERCENTAGE: "primaPercentage",
  PRIMA_DAYS: "primaDays",
} as const;

export const ACCRUALS_TABLE_COLUMN_HEADERS = {
  [ACCRUALS_TABLE_COLUMN_KEYS.REGISTRATION_DATE]: "Fecha",
  [ACCRUALS_TABLE_COLUMN_KEYS.DESCRIPTION]: "Descripción",
  [ACCRUALS_TABLE_COLUMN_KEYS.VACATION_DAYS]: "Días vacaciones",
  [ACCRUALS_TABLE_COLUMN_KEYS.TAKEN_DAYS]: "Días tomados",
  [ACCRUALS_TABLE_COLUMN_KEYS.PRIMA_PERCENTAGE]: "% Prima",
  [ACCRUALS_TABLE_COLUMN_KEYS.PRIMA_DAYS]: "Días prima",
} as const;

type AccrualsColumnT = {
  field: string;
  header: string;
  sortable?: boolean;
  sortField?: string;
  align: ColumnAlignType;
  style: Record<string, string | number>;
  body?: (rowData: Record<string, unknown>) => ReactNode;
};

const isNegativeRow = (rowData: Record<string, unknown>) =>
  rowData.accrualType === NEGATIVE_ACCRUAL_TYPE;

export const ACCRUALS_TABLE_COLUMNS: AccrualsColumnT[] = [
  {
    field: ACCRUALS_TABLE_COLUMN_KEYS.REGISTRATION_DATE,
    header:
      ACCRUALS_TABLE_COLUMN_HEADERS[
        ACCRUALS_TABLE_COLUMN_KEYS.REGISTRATION_DATE
      ],
    sortable: true,
    sortField: ACCRUALS_TABLE_COLUMN_KEYS.REGISTRATION_DATE_VALUE,
    align: "left",
    style: { width: "10rem", minWidth: "10rem" },
    body: (rowData) => (rowData.registrationDate as string) || "-",
  },
  {
    field: ACCRUALS_TABLE_COLUMN_KEYS.DESCRIPTION,
    header:
      ACCRUALS_TABLE_COLUMN_HEADERS[ACCRUALS_TABLE_COLUMN_KEYS.DESCRIPTION],
    sortable: true,
    align: "left",
    style: { minWidth: "12rem", flex: 1 },
  },
  {
    field: ACCRUALS_TABLE_COLUMN_KEYS.VACATION_DAYS,
    header:
      ACCRUALS_TABLE_COLUMN_HEADERS[ACCRUALS_TABLE_COLUMN_KEYS.VACATION_DAYS],
    sortable: true,
    align: "left",
    style: { minWidth: "9rem", flex: 1 },
    body: (rowData) =>
      isNegativeRow(rowData) ? "-" : `${rowData.vacationDays as number} días`,
  },
  {
    field: ACCRUALS_TABLE_COLUMN_KEYS.TAKEN_DAYS,
    header:
      ACCRUALS_TABLE_COLUMN_HEADERS[ACCRUALS_TABLE_COLUMN_KEYS.TAKEN_DAYS],
    sortable: true,
    align: "left",
    style: { minWidth: "9rem", flex: 1 },
    body: (rowData) =>
      isNegativeRow(rowData) ? `${rowData.vacationTaken as number} días` : "-",
  },
  // TODO: descomentar para reactivar.  % prima vacacional y días prima ya no se capturan/editan manualmente
  // {
  //   field: ACCRUALS_TABLE_COLUMN_KEYS.PRIMA_PERCENTAGE,
  //   header:
  //     ACCRUALS_TABLE_COLUMN_HEADERS[
  //       ACCRUALS_TABLE_COLUMN_KEYS.PRIMA_PERCENTAGE
  //     ],
  //   sortable: true,
  //   align: "left",
  //   style: { minWidth: "7rem", flex: 1 },
  //   body: (rowData) => `${rowData.primaPercentage as number}`,
  // },
  // {
  //   field: ACCRUALS_TABLE_COLUMN_KEYS.PRIMA_DAYS,
  //   header:
  //     ACCRUALS_TABLE_COLUMN_HEADERS[ACCRUALS_TABLE_COLUMN_KEYS.PRIMA_DAYS],
  //   sortable: true,
  //   align: "left",
  //   style: { minWidth: "7rem", flex: 1 },
  //   body: (rowData) => `${rowData.primaDays as number}`,
  // },
];
